import React from 'react';
import { PopupOrPanel } from '../../components/popupsAndPanels/PopupAndPanels';

type Props = {
  panelOpen: boolean;
  togglePanelOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onContinue: any;
};

export const SubscriptionDoubleSubDiscountSameLengthSubs: React.FC<Props> = ({
  panelOpen,
  togglePanelOpen,
  onContinue,
}) => {
  return (
    <PopupOrPanel
      isPopup={true}
      isOpen={panelOpen}
      hdrTitle={'Double Subject Discount'}
      position="right"
      primaryBtnTxt="Continue"
      secondaryBtnTxt="Cancel"
      givenClass="SubscriptionDoubleSubDiscountModal"
      primaryBtnColor="BtnOrange"
      secondaryBtnColor="BtnGrey"
      handleClose={() => togglePanelOpen(false)}
      handlePrimaryBtn={() => onContinue()}
      handleSecondaryBtn={() => togglePanelOpen(false)}
      width={560}
    >
      <p>Select the same length subscription to receive a double subject discount.</p>
    </PopupOrPanel>
  );
};
